import firebase from 'firebase/app';
import 'firebase/firestore';

export default (chatId, callback) =>
  firebase.firestore().collection('chats').doc(chatId).onSnapshot(callback);
